import {BehaviorSubject, Observable} from 'rxjs';

export class OpportunityNotificationToggleService {

    static instance = [OpportunityNotificationToggleService];

    private toggleValueSubject: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(false);
    private toggleValue: boolean;

    constructor() {
        this.toggleValueSubject.subscribe(val => this.toggleValue = val);
    }

    updateToggleValue = (value: boolean): void => {
        this.toggleValueSubject.next(value);
    };

    getToggleValueObservable = (): Observable<boolean> => {
        return this.toggleValueSubject.asObservable();
    };

    toggle = () => this.toggleValueSubject.next(!this.toggleValue);
}